<template>
  <div class="wrapper--pageform" v-if="$v">
    <h3 class="mb-15">สมัครสมาชิก / เข้าสู่ระบบ</h3>
    <div class="form__item--block">
      <label class="form__label" for="edit-email">
        <span class="ic-label"><img src="../assets/img/icon/mail@2x.png" width="25px" /></span>
        อีเมล หรือ เบอร์โทรศัพท์
      </label>

      <input id="edit-email" type="text" class="form__text" v-model="email" />
      <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล หรือ เบอร์โทรศัพท์</div>
      <div class="alert alert--error" v-show="!$v.$errors.email.empty && $v.$errors.email.invalid">กรุณากรอกอีเมล หรือ เบอร์โทรศัพท์ ให้ถูกต้อง</div>
    </div>

    <div>
      <label class="form__label" for="edit-password"><span class="ic-label"><img src="../assets/img/icon/password@2x.png" width="25px" /></span>รหัสผ่าน</label>
      <input id="edit-password" type="password" class="form__text" v-model="password" />
      <div class="alert alert--error" v-show="$v.$errors.password.empty">กรุณากรอกรหัสผ่าน</div>
      <div class="alert alert--error" v-show="$v.$errors.password.minLength">รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร</div>
    </div>

    <div class="button-actions">
      <button class="btn btn-login-button" type="button" @click.prevent="submit" :disabled="submitting">{{ submitButtonText }}</button>
      <div class="text-center small">หรือ</div>
      <facebook-login class="fb-login" @success="success" />
    </div>

    <a class="fl-left btn-link btn-back" href="#" @click.prevent="cancel" v-if="backButton">{{ backButtonText }}</a>
    <a class="fl-right btn-link btn-forgot" href="#" @click.prevent="gotoForgot">ลืมรหัสผ่าน?</a>
  </div>
</template>

<script>
  import FacebookLogin from './FacebookLogin.vue'

  export default {
    name: 'PageRegisterForm',

    components: {
      FacebookLogin
    },

    props: {
      next: {
        type: String,
        default: ''
      },
      submitButtonText: {
        type: String,
        default: 'บันทึก'
      },
      backButton: {
        type: Boolean,
        default: true
      },
      backButtonText: {
        type: String,
        default: '<< กลับ'
      }
    },

    data () {
      return {
        isLoginForm: true,
        email: '',
        password: '',
        $v: null,
        submitting: false
      }
    },

    created () {
      this.$v = this.$validator.init(this, {
        email: { checkEmpty: true, checkEmailOrPhone: true },
        password: { checkEmpty: true, minLength: 6 }
      })
    },

    methods: {
      gotoForgot () {
        this.$loginModal.hide()
        this.$router.push('/user/forgot')
      },

      submit () {
        this.email = this.$utils.cleanEmailInvisibleChars(this.email)

        if (!this.$v.validate()) {
          this.$forceUpdate()
          return
        }

        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังเข้าสู่ระบบ ...',
          okButton: false
        })

        this.submitting = true
        this.login()
      },

      success () {
        if (this.next) {
          this.$router.push(this.next)
        } else {
          this.$emit('submit')
        }
      },

      login () {
        const payload = {
          email: this.email,
          password: this.password
        }
        this.$http.post('members/login', payload, { autoLogout: false })
          .then(resp => {
            this.submitting = false
            this.$modal.hide()
            return this.$utils.processLoginResponse(resp)
          })
          .then(() => {
            this.$store.state.toast.showToast(`คุณได้เข้าสู่ระบบเรียบร้อยแล้ว`, { timeLife: 1200 })
            this.success()
          })
          .catch(err => {
            console.error(err)
            this.submitting = false

            let text = 'ไม่สามารถดึงข้อมูลผู้ใช้ได้ กรุณาลองใหม่อีกครั้ง'

            if (err.body && err.body.message === 'Login fail: Incorrect Username / Password') {
              text = 'อีเมล เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง'
            }

            this.$modal.show({
              title: 'ผิดพลาด',
              text: text
            })
          })
      },

      cancel () {
        this.$emit('cancel')
      }
    }
  }
</script>

<style lang="scss" scoped>
.wrapper--pageform {
  overflow: hidden;
  .ic-label {
    float: left;
    width: 30px;
    img { display: block;}
  }
}
.btn-link {
  line-height: 50px;
  font-size: 1.2em;
}
  .btn-login-button {
    width: 100%;
  }
  .btn-forgot {
    font-size: 0.9em;
  }
</style>



// WEBPACK FOOTER //
// PageRegisterForm.vue?21846bcd